import VideoHeroSection from '@/components/landing/VideoHeroSection';
import ClosedLoopWorkflowSection from '@/components/landing/ClosedLoopWorkflowSection';
import FounderNarrativeSection from '@/components/landing/FounderNarrativeSection';
import ValuePillarsSection from '@/components/landing/ValuePillarsSection';
import ROIAchievementSection from '@/components/landing/ROIAchievementSection';
import ComplianceBlock from '@/components/landing/ComplianceBlock';
import ExecutiveCTASection from '@/components/landing/ExecutiveCTASection';

const Landing = () => {
  return (
    <>
      <VideoHeroSection />
      <ClosedLoopWorkflowSection />
      <FounderNarrativeSection />
      <ValuePillarsSection />
      <ROIAchievementSection />
      <ComplianceBlock />
      <ExecutiveCTASection />
    </>
  );
};

export default Landing;
